/* global axios */
import ApiClient from './ApiClient';

class MailingListsAPI extends ApiClient {
  constructor() {
    super('mailing_lists', { accountScoped: true });
  }

  subscribe(mailingListId, contactIds, source = 'admin') {
    return axios.post(`${this.url}/${mailingListId}/subscriptions`, {
      subscription: {
        contact_ids: contactIds,
        source,
      },
    });
  }

  unsubscribe(mailingListId, subscriptionId, reason = '') {
    return axios.delete(
      `${this.url}/${mailingListId}/subscriptions/${subscriptionId}`,
      {
        params: { reason },
      }
    );
  }
}

export default new MailingListsAPI();
